import { TextArea } from "@flow/frontend/member/components/TextArea";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export function SendAMessageEmailForm(props: {
  samPrefillEnabled: boolean;
  memberMessageSubject: string;
  memberMessageBody: string;
  onMemberMessageSubjectChange: (subject: string) => void;
  onMemberMessageBodyChange: (body: string) => void;
}) {
  const {
    samPrefillEnabled,
    memberMessageSubject,
    memberMessageBody,
    onMemberMessageSubjectChange,
    onMemberMessageBodyChange,
  } = props;

  return (
    <>
      <TextArea label="Subject" value={memberMessageSubject} onChange={onMemberMessageSubjectChange} />

      {samPrefillEnabled ? (
        <>
          <Box
            contentEditable={true}
            dangerouslySetInnerHTML={{ __html: memberMessageBody }}
            onInput={({ currentTarget: { innerHTML } }) => onMemberMessageBodyChange(innerHTML)}
            sx={{
              border: "1px solid #ced4da",
              padding: 1,
              minHeight: "150px",
              maxHeight: "300px",
              overflowY: "auto",
              marginBottom: 2,
            }}
          />
          {/* Hidden TextField used to capture form submission */}
          <TextField
            required
            id="message-body"
            name="message_body"
            value={memberMessageBody}
            onChange={({ currentTarget: { value } }) => onMemberMessageBodyChange(value)}
            hidden
          />
        </>
      ) : (
        <TextArea
          label="Message"
          value={memberMessageBody}
          onChange={onMemberMessageBodyChange}
          minRows={3}
          inputLabelShrink={true}
          sx={{ marginBottom: "0" }}
        />
      )}
    </>
  );
}
